import { ZonedDateTime } from '@internationalized/date';
import {
  ActionType,
  AddressType,
  ServiceStatus,
} from '@rematter/frontend-lib-api-client';

import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useServiceCreateMutation = createMutationHook(
  'transportation.serviceCreate',
  (params: {
    serviceTypeId: string;
    status?: ServiceStatus;
    rank?: string;
    priority: number;
    scheduledWindowStart: ZonedDateTime;
    scheduledWindowEnd: ZonedDateTime;
    internalNotes?: string;
    externalNotes?: string;
    driverNotes?: string;
    driverId?: string;
    haulerId?: string;
    truckId?: string;
    trailerId?: string;
    routeId?: string | null;
    facilityGroupId?: string;
    facilityId?: string | null;
    destinationFacilityId?: string | null;
    accountId?: string | null;
    accountAddressId?: string | null;
    contactId?: string | null;
    estimatedArrival?: ZonedDateTime;
    actions?: {
      actionType?: ActionType;
      assetTypeId: string;
      assetId?: string;
      quantity?: number;
      assetGroup?: number;
    }[];
    address?: {
      streetAddress: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
      addressType: AddressType;
      isMailingAddress: boolean;
      coordinates?: {
        latitude: number;
        longitude: number;
      };
    };
  }) => ({
    transportationServiceCreate: {
      __args: {
        input: {
          serviceTypeId: params.serviceTypeId,
          status: params.status,
          rank: params.rank,
          priority: params.priority,
          scheduledWindowStart: params.scheduledWindowStart.toAbsoluteString(),
          scheduledWindowEnd: params.scheduledWindowEnd.toAbsoluteString(),
          internalNotes: params.internalNotes,
          externalNotes: params.externalNotes,
          driverNotes: params.driverNotes,
          driverId: params.driverId,
          haulerId: params.haulerId,
          truckId: params.truckId,
          trailerId: params.trailerId,
          estimatedArrival: params.estimatedArrival?.toAbsoluteString(),
          accountId: params.accountId,
          accountAddressId: params.accountAddressId,
          contactId: params.contactId,
          address: params.address,
          actions: params.actions,
          facilityGroupId: params.facilityGroupId,
          facilityId: params.facilityId,
          destinationFacilityId: params.destinationFacilityId,
          routeId: params.routeId,
          isTemplate: false,
          isRequest: false,
        },
      },
      ...SERVICE_FRAGMENT,
    },
  }),
  {
    select: ({ transportationServiceCreate: service }) => mapService(service),
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
